import api from '../../services/api';

const baseUrl = 'notifications';

const findMine = ({ pageIndex, pageSize }) =>
    api.get({ service: `${baseUrl}/me`, queryString: { pageIndex, pageSize } });

const readAll = () =>
    api.put({ service: `${baseUrl}/read-all` });

const read = (id) =>
    api.put({ service: `${baseUrl}/${id}` });

const clearAll = () =>
    api.remove({ service: `${baseUrl}/me` });

export default {
    findMine,
    readAll,
    read,
    clearAll
}
